export default {
  eula: 'End User License Agreement',
  eulaAbbr: 'EULA',
} as const;
